/**
 * Query-key factory.
 *
 * Every key is built here so invalidation is precise and greppable: keys are
 * hierarchical arrays, and invalidating a prefix invalidates everything beneath
 * it. Inline literal keys are what make caches go stale in ways nobody can
 * trace, so they are not used anywhere in the apps.
 *
 * Convention: [module, entity, ...discriminators]
 *
 *   queryKeys.module('content').entity('articles').list({ page: 1 })
 *     -> ['content', 'articles', 'list', { page: 1 }]
 */
export const queryKeys = {
  module: (module: string) => ({
    all: [module] as const,

    entity: (entity: string) => ({
      all: [module, entity] as const,
      lists: () => [module, entity, 'list'] as const,
      list: (params?: Record<string, unknown>) => [module, entity, 'list', params ?? {}] as const,
      details: () => [module, entity, 'detail'] as const,
      detail: (id: string) => [module, entity, 'detail', id] as const,
    }),
  }),
} as const;

export type QueryKey = readonly unknown[];
